import clsx from 'clsx';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

export function Spinner({ size = 'md', className, label }: SpinnerProps) {
  const sizeClass = size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-10 w-10' : 'h-6 w-6';
  return (
    <span className={clsx('inline-flex items-center gap-2', className)} role="status">
      <span
        className={clsx(
          'inline-block animate-spin rounded-full border-2 border-foam/30 border-t-green',
          sizeClass,
        )}
        aria-hidden
      />
      {label ? <span className="text-sm text-mist">{label}</span> : null}
      <span className="sr-only">Loading</span>
    </span>
  );
}
